import routerOptions0 from "/home/runner/work/seed/seed/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  scrollBehaviorType: "smooth",
  hashMode: false
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}